<template>
  <a-modal
    :visible="visible"
    title="Tạo Entry mới"
    :width="760"
    :mask-closable="false"
    :keyboard="false"
    :confirm-loading="Submitting"
    @cancel="Close"
  >
    <a-alert
      v-if="DuplicateEntry"
      type="warning"
      show-icon
      class="manual-entry-alert"
      message="Mã trúng thưởng đã được sử dụng"
    >
      <div slot="description">
        <div>
          <strong>Request ID:</strong>

          <a
            v-if="DuplicateEntry.Request_ID"
            href="javascript:void(0)"
            @click.stop="OpenEntry(DuplicateEntry)"
          >
            {{ DuplicateEntry.Request_ID }}
            <a-icon type="export" />
          </a>

          <span v-else>-</span>
        </div>

        <div>
          <strong>Họ tên:</strong>
          {{ DuplicateEntry.Full_Name || "-" }}
        </div>

        <div>
          <strong>SĐT:</strong>
          {{ DuplicateEntry.User_ID || "-" }}
        </div>

        <div>
          <strong>Ngày nhập:</strong>
          {{ FormatDateTime(DuplicateEntry.Created_At) }}
        </div>
      </div>
    </a-alert>

    <a-alert
      v-if="CreatedEntry"
      type="success"
      show-icon
      class="manual-entry-alert"
      message="Đã tạo Entry thành công"
    >
      <div slot="description">
        Request ID:

        <a href="javascript:void(0)" @click.stop="OpenEntry(CreatedEntry)">
          {{ CreatedEntry.Request_ID }}
          <a-icon type="export" />
        </a>
      </div>
    </a-alert>
    <a-form-model
      ref="ManualEntryForm"
      class="manual-entry-form"
      :model="Form"
      :rules="Rules"
      layout="vertical"
    >
      <a-row :gutter="12">
        <a-col :md="12" :xs="24">
          <a-form-model-item label="Họ tên" prop="Full_Name">
            <a-input
              v-model.trim="Form.Full_Name"
              placeholder="Nhập họ tên"
              :disabled="!!CreatedEntry"
            />
          </a-form-model-item>
        </a-col>

        <a-col :md="12" :xs="24">
          <a-form-model-item label="Ngày sinh" prop="DoB">
            <date-input
              v-model="Form.DoB"
              :minimum-age="18"
              :maximum-age="100"
              :disabled="!!CreatedEntry"
              required
            />
          </a-form-model-item>
        </a-col>

        <a-col :md="12" :xs="24">
          <a-form-model-item label="SĐT" prop="Phone">
            <a-input
              v-model.trim="Form.Phone"
              :max-length="12"
              placeholder="VD: 0901234567"
              :disabled="!!CreatedEntry"
            />
          </a-form-model-item>
        </a-col>

        <a-col :md="12" :xs="24">
          <a-form-model-item label="Hình thức nhận">
            <a-radio-group
              v-model="Form.IsCashout"
              class="payout-group"
              :disabled="!!CreatedEntry"
            >
              <a-radio-button class="payout-cash" :value="true">
                <i class="fa fa-money" aria-hidden="true"></i>
                TIỀN MẶT
              </a-radio-button>

              <a-radio-button class="payout-voucher" :value="false">
                <a-icon type="gift" />
                VOUCHER
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :md="12" :xs="24">
          <a-form-model-item label="CCCD" prop="CCCD">
            <a-input
              v-model.trim="Form.CCCD"
              :max-length="20"
              placeholder="Nhập số CCCD"
              :disabled="!!CreatedEntry"
            />
          </a-form-model-item>
        </a-col>

        <a-col :md="12" :xs="24">
          <a-form-model-item label="Giới tính" prop="Gender">
            <a-radio-group v-model="Form.Gender" :disabled="!!CreatedEntry">
              <a-radio value="Male"> Nam </a-radio>

              <a-radio value="Female"> Nữ </a-radio>

              <a-radio value="Other"> Khác </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="24">
          <a-form-model-item label="Khu vực" prop="Region">
            <a-radio-group
              v-model="Form.Region"
              class="region-button-group"
              button-style="solid"
              :disabled="!!CreatedEntry"
            >
              <a-radio-button
                v-for="Region in RegionOptions"
                :key="Region"
                :value="Region"
              >
                {{ Region }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="24">
          <a-form-model-item label="Địa chỉ" prop="Address">
            <a-input
              v-model.trim="Form.Address"
              placeholder="Nhập địa chỉ"
              :disabled="!!CreatedEntry"
            />
          </a-form-model-item>
        </a-col>

        <a-col :span="24">
          <a-form-model-item label="Mã trúng thưởng" prop="Scratch_Code">
            <div class="manual-entry-code-row">
              <a-radio-group
                v-model="Form.Scratch_Type"
                button-style="solid"
                :disabled="!!CreatedEntry"
                @change="OnScratchTypeChange"
              >
                <a-radio-button value="CAP_5"> Nắp - 5 ký tự </a-radio-button>

                <a-radio-button value="RING_6">
                  Khoén - 6 ký tự
                </a-radio-button>
              </a-radio-group>

              <a-input
                v-model="Form.Scratch_Code"
                class="manual-entry-code-input"
                :max-length="ScratchCodeLength"
                :placeholder="`Nhập đúng ${ScratchCodeLength} ký tự`"
                :disabled="!!CreatedEntry"
                @input="NormalizeScratchInput"
              />
            </div>
          </a-form-model-item>
        </a-col>

        <a-col :md="12" :xs="24">
          <upload-image
            v-model="ScratchImageFile"
            label="Ảnh mã trúng thưởng (không bắt buộc)"
              :disabled="!!CreatedEntry"
            :max-size-mb="8"
            :show-file-name="true"
          />
        </a-col>

        <a-col :md="12" :xs="24">
          <upload-image
            v-model="CCCDImageFile"
            label="Ảnh CCCD (không bắt buộc)"
              :disabled="!!CreatedEntry"
            :max-size-mb="8"
            :show-file-name="true"
          />
        </a-col>
      </a-row>
    </a-form-model>

    <template slot="footer">
      <a-button @click="Close"> Đóng </a-button>

      <a-button
        type="primary"
        icon="plus"
        :loading="Submitting"
        :disabled="!!CreatedEntry"
        @click="Submit"
      >
        Tạo Entry
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import axios from "axios";
import DateInput from "@/components/DateInput.vue";
import UploadImage from "@/components/UploadImage.vue";
import { message } from "ant-design-vue";
export default {
  name: "EntryManualCreateModal",

  components: {
    DateInput,
    UploadImage,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      Submitting: false,

      DuplicateEntry: null,
      CreatedEntry: null,

      ScratchImageFile: null,
      CCCDImageFile: null,

      RegionOptions: [
        "Sông Tiền",
        "Nam Trung Bộ",
        "Tây Nguyên",
        "Trung Tâm",
        "Miền Đông",
        "Sông Hậu",
      ],

      Form: this.BuildDefaultForm(),

      Rules: {
        Full_Name: [
          {
            required: true,
            message: "Vui lòng nhập họ tên.",
            trigger: "blur",
          },
        ],

        DoB: [
          {
            required: true,
            message: "Vui lòng nhập ngày sinh.",
            trigger: ["blur", "change"],
          },
        ],

        Phone: [
          {
            required: true,
            message: "Vui lòng nhập SĐT.",
            trigger: "blur",
          },
          {
            validator: (Rule, Value, Callback) => {
              const Phone = this.NormalizePhone(Value);

              if (!/^0\d{9}$/.test(Phone)) {
                Callback(new Error("SĐT phải có 10 chữ số và bắt đầu bằng 0."));

                return;
              }

              Callback();
            },
            trigger: "blur",
          },
        ],

        CCCD: [
          {
            required: true,
            message: "Vui lòng nhập CCCD.",
            trigger: "blur",
          },
        ],

        Gender: [
          {
            required: true,
            message: "Vui lòng chọn giới tính.",
            trigger: "change",
          },
        ],

        Region: [
          {
            required: true,
            message: "Vui lòng chọn khu vực.",
            trigger: "change",
          },
        ],

        Address: [
          {
            required: true,
            message: "Vui lòng nhập địa chỉ.",
            trigger: "blur",
          },
        ],

        Scratch_Code: [
          {
            required: true,
            message: "Vui lòng nhập mã trúng thưởng.",
            trigger: "blur",
          },
          {
            validator: (Rule, Value, Callback) => {
              const Code = String(Value || "")
                .replace(/\s+/g, "")
                .toUpperCase();

              if (Code.length !== this.ScratchCodeLength) {
                Callback(
                  new Error(`Mã phải có đúng ${this.ScratchCodeLength} ký tự.`),
                );

                return;
              }

              Callback();
            },
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },

  computed: {
    ScratchCodeLength() {
      return this.Form.Scratch_Type === "RING_6" ? 6 : 5;
    },

    oUser() {
      return this.$store.state.oUser || {};
    },
  },

  watch: {
    visible(Value) {
      if (Value) {
        this.Reset();
      }
    },
  },

  methods: {
    BuildDefaultForm() {
      return {
        Full_Name: "",
        DoB: "",
        Phone: "",
        CCCD: "",
        Gender: "",
        Region: "",
        Address: "",

        Scratch_Type: "CAP_5",

        Scratch_Code: "",

        /*
         * Mặc định nhận tiền mặt.
         */
        IsCashout: true,
      };
    },

    GetToken() {
      return (
        (this.oUser && this.oUser.Token) || localStorage.getItem("Token") || ""
      );
    },

    NormalizePhone(Value) {
      let Phone = String(Value || "")
        .replace(/[\s().-]/g, "")
        .trim();

      if (Phone.length === 9) {
        Phone = "0" + Phone;
      } else if (Phone.indexOf("84") === 0) {
        Phone = "0" + Phone.substring(2);
      }

      return Phone;
    },

    NormalizeScratchInput() {
      /*
       * Dùng trực tiếp v-model.
       * Không đọc argument @input để tránh trường hợp
       * component emit event object -> "[OBJECT OBJECT]".
       */
      this.Form.Scratch_Code = String(this.Form.Scratch_Code || "")
        .replace(/\s+/g, "")
        .toUpperCase()
        .slice(0, this.ScratchCodeLength);
    },

    OnScratchTypeChange() {
      this.Form.Scratch_Code = "";

      this.DuplicateEntry = null;

      this.$nextTick(() => {
        if (this.$refs.ManualEntryForm) {
          this.$refs.ManualEntryForm.clearValidate("Scratch_Code");
        }
      });
    },

    CreateBlankImageFile(FileName) {
      /*
       * PNG 1x1 trong suốt hợp lệ.
       * Sau IEND có thể có trailing bytes; browser/image decoder vẫn đọc PNG.
       * Pad đúng 1024 bytes để flow upload luôn có file ~1KB.
       */
      const Base64 =
        "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=";

      const Binary = window.atob(Base64);

      const PNGBytes = new Uint8Array(Binary.length);

      for (let Index = 0; Index < Binary.length; Index += 1) {
        PNGBytes[Index] = Binary.charCodeAt(Index);
      }

      const TargetSize = 1024;

      const PaddingSize = Math.max(0, TargetSize - PNGBytes.length);

      const Padding = new Uint8Array(PaddingSize);

      return new File([PNGBytes, Padding], FileName || "blank.png", {
        type: "image/png",
        lastModified: Date.now(),
      });
    },





    Reset() {
      this.Submitting = false;

      this.DuplicateEntry = null;

      this.CreatedEntry = null;

      this.ScratchImageFile = null;

      this.CCCDImageFile = null;

      this.Form = this.BuildDefaultForm();

      this.$nextTick(() => {
        if (this.$refs.ManualEntryForm) {
          this.$refs.ManualEntryForm.clearValidate();
        }
      });
    },

    Close() {
      if (this.Submitting) {
        return;
      }

      this.$emit("close");
    },

    OpenEntry(Entry) {
      const RequestID = String((Entry && Entry.Request_ID) || "").trim();

      if (!RequestID) {
        return;
      }

      /*
       * Mở link đơn giản.
       * Không dùng:
       * const URL = new URL(...)
       * để tránh lỗi Cannot access 'URL' before initialization.
       */
      window.open(
        window.location.origin +
          "/?Request_ID=" +
          encodeURIComponent(RequestID),
        "_blank",
      );
    },

    FormatDateTime(Value) {
      if (!Value) {
        return "-";
      }

      const DateValue = new Date(Value);

      if (Number.isNaN(DateValue.getTime())) {
        return "-";
      }

      return DateValue.toLocaleString("vi-VN");
    },

    Validate() {
      return new Promise((Resolve) => {
        this.$refs.ManualEntryForm.validate((Valid) => Resolve(Valid));
      });
    },

    async Submit() {
      this.DuplicateEntry = null;

      const Valid = await this.Validate();

      if (!Valid) {
        return;
      }

      this.Submitting = true;

      try {
        const Data = new FormData();

        Data.append("Full_Name", this.Form.Full_Name.trim());

        /*
         * DateInput dùng cùng component với website.
         * Giữ nguyên value mà component trả về.
         */
        Data.append("DoB", this.Form.DoB || "");

        Data.append("Phone", this.NormalizePhone(this.Form.Phone));

        Data.append("CCCD", String(this.Form.CCCD || "").trim());

        Data.append("Gender", String(this.Form.Gender || "").trim());

        Data.append("Region", String(this.Form.Region || "").trim());

        Data.append("Address", this.Form.Address.trim());

        Data.append("Scratch_Type", this.Form.Scratch_Type);

        Data.append(
          "Scratch_Code",
          String(this.Form.Scratch_Code || "")
            .replace(/\s+/g, "")
            .toUpperCase(),
        );

        Data.append("IsCashout", this.Form.IsCashout ? "true" : "false");

        /*
         * Hai ảnh vẫn optional trên UI.
         * Nếu user không chọn, gửi ảnh PNG trống đúng 1KB để
         * luồng Entry/Detail cũ vẫn có path ảnh và hiển thị đầy đủ.
         */
        const ScratchImage =
          this.ScratchImageFile ||
          this.CreateBlankImageFile("manual_scratch_blank.png");

        const CCCDImage =
          this.CCCDImageFile ||
          this.CreateBlankImageFile("manual_cccd_blank.png");

        Data.append("Scratch_Code_Image", ScratchImage);

        Data.append("CCCD_Image", CCCDImage);

        const Domain = String(this.$PRJ_DOMAIN || "").replace(/\/$/, "");

        const Response = await axios.post(
          Domain + "/crm/api/entry/manual-create",
          Data,
          {
            headers: {
              "X-CRM-Token": this.GetToken(),
            },

            timeout: 120000,
          },
        );

        const Result = Response && Response.data ? Response.data : null;

        if (!Result || Number(Result.State) !== 1) {
          if (Result && Result.Case === "SCRATCH_DUPLICATE") {
            this.DuplicateEntry =
              Result.Data && Result.Data.Existing_Entry
                ? Result.Data.Existing_Entry
                : {};

            return;
          }

          message.error(
            Result && Result.Message ? Result.Message : "Không tạo được Entry.",
          );

          return;
        }

        this.CreatedEntry = (Result.Data && Result.Data.Entry) || {
          Request_ID: Result.Data && Result.Data.Request_ID,
        };

        message.success(Result.Message || "Đã tạo Entry.");

        this.$emit("created", this.CreatedEntry);
      } catch (Error) {
        const Result =
          Error && Error.response && Error.response.data
            ? Error.response.data
            : null;

        if (Result && Result.Case === "SCRATCH_DUPLICATE") {
          this.DuplicateEntry =
            Result.Data && Result.Data.Existing_Entry
              ? Result.Data.Existing_Entry
              : {};

          return;
        }

        message.error(
          Result && Result.Message
            ? Result.Message
            : "Không kết nối được máy chủ.",
        );
      } finally {
        this.Submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.manual-entry-form
>>> .ant-form-item {
  margin-bottom: 6px;
}

.manual-entry-form
>>> .ant-form-item-label {
  padding-bottom: 2px;
  line-height: 20px;
}

.manual-entry-form
>>> .ant-form-item-label > label {
  height: 20px;
  line-height: 20px;
}

.manual-entry-form
>>> .ant-form-explain {
  margin-top: 2px;
  font-size: 12px;
}
.manual-entry-alert {
  margin-bottom: 14px;
}

.manual-entry-code-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.manual-entry-code-input {
  flex: 1;
  min-width: 180px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 1px;
}

/*
 * Hình thức nhận:
 * 2 button lớn, full width.
 */
.payout-group {
  display: flex;
  width: 100%;
}

.payout-group .ant-radio-button-wrapper {
  flex: 1;
  padding: 0 14px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  transition: all 0.2s;
}

/* TIỀN MẶT */
.payout-cash {
  color: #389e0d;
}

.payout-cash.ant-radio-button-wrapper-checked {
  color: #fff !important;
  background: #52c41a !important;
  border-color: #52c41a !important;
  box-shadow: -1px 0 0 0 #52c41a !important;
}

.payout-cash.ant-radio-button-wrapper-checked::before {
  background-color: #52c41a !important;
}

/* VOUCHER */
.payout-voucher {
  color: #fa8c16;
}

.payout-voucher.ant-radio-button-wrapper-checked {
  color: #fff !important;
  background: #fa8c16 !important;
  border-color: #fa8c16 !important;
  box-shadow: -1px 0 0 0 #fa8c16 !important;
}

.payout-voucher.ant-radio-button-wrapper-checked::before {
  background-color: #fa8c16 !important;
}

.payout-group i,
.payout-group .anticon {
  margin-right: 6px;
  font-size: 16px;
}

@media (max-width: 767px) {
  .manual-entry-code-row {
    display: block;
  }

  .manual-entry-code-input {
    width: 100%;
    margin-top: 8px;
  }

  .payout-group {
    display: block;
  }

  .payout-group .ant-radio-button-wrapper {
    width: 50%;
  }
}
</style>
